let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kRe79")).then(() => parcelRequire('j974q'));